import { DCFlashcard } from '@dataclouder/dc-flashcard';
import { TranscriptionsWhisper } from '@dataclouder/ngx-agent-cards'; // Import TranscriptionsWhisper

import { AudioStorage, StorageFile } from '../classes';
import { WordType } from '../enums'; // Removed VerbTense

export const LangCodeDescription = {
  es: 'Spanish',
  en: 'English',
  it: 'Italian',
  pt: 'Portuguese',
  fr: 'French',
  ja: 'Japanese',
};

export const GetLangDesc = (langCode: string) => {
  return LangCodeDescription[langCode];
};

export const LangCodeDescriptionEs = {
  es: 'Español',
  en: 'Inglés',
  it: 'Italiano',
  pt: 'Portugués',
  fr: 'Frances',
  ja: 'Japonés',
};

export const LevelDescription = {
  1: 'Beginner',
  2: 'Beginner Pre-Intermediate',
  3: 'Intermediate',
  4: 'Upper-Intermediate',
  5: 'Advanced and Proficient',
  6: 'Master',
};
export class AuditData {
  createdDate: string;
  modifiedDate: string;
}

export type ValidTables = 'word_en' | 'word_es' | 'word_it' | 'word_pt' | 'word_fr' | 'word_ja';

export type ValidNodeTables =
  | 'knowledgeState.en.word'
  | 'knowledgeState.es.word'
  | 'knowledgeState.it.word'
  | 'knowledgeState.pt.word'
  | 'knowledgeState.fr.word'
  | 'knowledgeState.ja.word';

export class UserExtraData extends AuditData {
  progress: number;
  completed: boolean;
}

export class GeneralWord extends AuditData {
  id: string;
  word: string;
  synonyms: Array<string>;
  definitions: Array<string>;
  examples: Array<string>;

  hispanicPhonetic: string;
  ipaPhonetic: string;
  respelledPhonetic: string;

  wordCategory: string; // before partOfSpeech
  lemma: string;
  baseVerb: string;
  level: number;

  useFrequency: number;
  audios: Array<AudioStorage>;

  learningExamples: Array<LearningExample>;

  translation?: string; // take the value from language target
  otherTranslations?: Array<string>; // take the value from language target

  flashcards?: Array<DCFlashcard>;

  // Availible translations for the word
  es: { translation: string; otherTranslations: Array<string> };
  en: { translation: string; otherTranslations: Array<string> };

  audioUrl?: string; // Will be include in future verions
}

export class LangWord extends GeneralWord {
  wordType: WordType;
  // extra: JapaneseExtra | null; // Changed from any
  extra?: Record<string, string>;

  constructor(data: Partial<LangWord> = {}) {
    super();
    Object.assign(this, data);
  }
}

export interface JapaneseExtra {
  kanji: string;
  hiragana: string;
  katakana: string;
  romaji: string;
  kanjiExample: string;
  hiraganaExample: string;
  katakanaExample: string;
  romajiExample: string;
  spanishTranslation: string;
  englishTranslation: string;
}

export const JapaneseExtraString = `
{ 
  extra: {
    kanji: string;
    hiragana: string;
    katakana: string;
    romaji: string;
    kanjiExample: string;
    hiraganaExample: string;
    katakanaExample: string;
    romajiExample: string;
    spanishTranslation: string;
    englishTranslation: string;
  }
}`;

// This is interface for AI models.
export const LangWordStringInterface: string = `
{
  word: string;              // word to translate
  synonyms: Array<string>;   // synonyms of the word
  definitions: Array<string>; // definitions of the word
  examples: Array<string>;   // examples of the word

  hispanicPhonetic: string; // hispanic phonetic of the word
  ipaPhonetic: string;      // ipa phonetic of the word
  respelledPhonetic: string; // respelled phonetic of the word

  wordCategory: string; // category of the word like verb, noun, adjective, adverb, etc.
  lemma: string;         // lemma of the word
  baseVerb: string;      // base verb of the word
  level: number;         // level of the word from 1 to 5, five is the most difficult
  useFrequency: number;     // use frequency of the word from 1 to 5, five is the most used

  // Availible translations for the word
  es: { translation: string; otherTranslations: Array<string> };
  en: { translation: string; otherTranslations: Array<string> };
}
`;

// For future use this type
export type UserWord = LangWord & UserExtraData;

export class QuickPhrase {
  id: string;
  phrase: string;
  translation: { es: string; en: string };
  url: string;
  transcription: TranscriptionsWhisper; // Use specific type
}

export class LearningExample {
  _id: string; // id del learningExample de mongo.
  id: string;
  word?: string; // TODO: Sería más facil si word existe aunque este duplicado.
  example: string;
  meaning: string;
  scenario: string;
  picture: string;

  translation: string; // resverved for base language
  meaningTranslation: string; // reserved for base language

  es: { translation: string; meaningTranslation: string };
  en: { translation: string; meaningTranslation: string };

  audio: AudioStorage;
  image: StorageFile & { text: string };

  attribution: string;
  generatedByAI: boolean;
  author: string;
  difficultyLevel: string; // Deprecated
  level: string;
  tense?: string; // will help to practice verbs
  isPublic: boolean;
  quickPhrases: QuickPhrase[];
}
